import { render, staticRenderFns } from "./LoginFooter.vue?vue&type=template&id=331915f8&"
import script from "CY/components/speedTest/FooterSpeedTest.component?vue&type=script&lang=js&"
export * from "CY/components/speedTest/FooterSpeedTest.component?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports